import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';

const Radio = ({ id, name, checked, onChange, value, label, desc, customDescStyles, disabled }) => {
  const idFormatted = id ? `radio-${id}` : `radio-${value}`;

  return (
    <styles.RadioContainer customDescStyles={!!customDescStyles}>
      <styles.LabelContainer htmlFor={idFormatted}>
        <styles.InputContainer customDescStyles={!!customDescStyles}>
          <styles.RadioInput
            id={idFormatted}
            type="radio"
            value={value}
            name={name}
            checked={checked}
            onChange={onChange}
          />
          <styles.CustomRadio checked={checked} disabled={disabled} />
        </styles.InputContainer>
        <styles.DescContainer customDescStyles={customDescStyles}>
          <styles.Label>{label}</styles.Label>
          <styles.Desc>{desc}</styles.Desc>
        </styles.DescContainer>
      </styles.LabelContainer>
    </styles.RadioContainer>
  );
};

Radio.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any,
  label: PropTypes.string,
  desc: PropTypes.string,
  customDescStyles: PropTypes.object,
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Radio/index.js